import React from 'react';

import Flex from '../Flex/Flex';
import ItemsPerPage from './ItemsPerPage/ItemsPerPage';
import PageSelector from './PageSelector/PageSelector';
import { FlexProps } from '../Flex/Flex';

const Pagination: React.FunctionComponent<
  FlexProps<keyof JSX.IntrinsicElements>
> & {
  ItemsPerPage: typeof ItemsPerPage;
  PageSelector: typeof PageSelector;
} = ({ children, ...props }) => <Flex {...props}>{children}</Flex>;

Pagination.ItemsPerPage = ItemsPerPage;
Pagination.PageSelector = PageSelector;

export default Pagination;
